<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 7.67em;">Dallas</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 5.92em;">Forever</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 5.58em;">Changed</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-1__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 3.08em;">The Legacy of</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-2__And__Centre_Alignment"><span><span style=" font-weight: normal; font-style: normal; font-size: 3.08em;">November 1963</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?cfb0ae80